import template from './template.html';
import './styles.css';

controller.$inject = ['ShiftsService', 'DriversService', 'StoresService', '$scope', '$stateParams', '$state', '$q', 'Alerts', '$window', 'UserService', 'ReportsService', 'DateService', '$anchorScroll'];

function controller(ShiftsService, DriversService, StoresService, $scope, $stateParams, $state, $q, Alerts, $window, UserService, ReportsService, DateService, $anchorScroll) {
    let vm = {};
    let hasDownloadPermission = false;
    let hasCopyShiftPermission = false;
    let hasReportsPermission = false;
    this.$onInit = function() {
    vm = this;

    vm.driver = undefined;
    vm.date = new Date($stateParams.week);
    vm.date.setHours(12); //hack for Chrome 46 date issue.  Make sure we are not going back a day in DST by forcing to midday.
    vm.goToToday = goToToday;
    vm.ready = false;

    //reports related
    vm.reports = ['Shift Schedule', 'Driver Rotas', 'Unallocated Shifts'];
    vm.showReportsMenu = showReportsMenu;
    vm.reportsMenuOpen = false;
    vm.getReport = getReport;
    vm.reportsEnabled = false;
    UserService.isInRole('ViewReport').then(result => hasReportsPermission = result);

    //download related    
    vm.downloadEnabled = false;
    UserService.isInRole('DownloadPlanner').then(result => hasDownloadPermission = result);

    //copy shifts related
    vm.copySourceWeek = new Date(vm.date);
    vm.copyMenuOpen = false;
    vm.showCopyMenu = showCopyMenu;
    vm.copyWeek = copyWeek;
    vm.copyMenuEnabled = false;
    UserService.isInRole('CopyShift').then(result => hasCopyShiftPermission = result);

    //paging related 
    vm.currentShiftsPage = 1;
    vm.nextPage = nextPage;
    vm.previousPage = previousPage;
    vm.pagingBarIsEnabled = pagingBarIsEnabled;

    /////////// initialisation ///////////
    UserService.isInStore().then(result => vm.isInStore = result);

    if (isNaN(vm.date.getTime())) {
        $state.go('schedules');
    }

    refreshData();
    }
    ////////// methods //////////

    function refreshData() {
        if (vm.loading) return;
        vm.loading = true;
        const id = vm.driver && vm.driver.id;

        const promises = {
            drivers: DriversService.getDrivers(vm.date),
            shifts: ShiftsService.getShifts(vm.date, id, vm.currentShiftsPage),
            driversShifts: id && ShiftsService.getAllocatedForDriver(vm.date, id),
        };

        $q.all(promises).then(values => {
            vm.drivers = values.drivers;
            vm.driversShifts = values.driversShifts;
            const shifts = values && values.shifts ? values.shifts : [];
            setShiftRelatedProperties(shifts);
            vm.loading = false;
            vm.ready = true;
        });
    }

    function getShiftsForCurrentPage() {
        if (vm.loading) return;
        vm.loading = true;
        const id = vm.driver && vm.driver.id;
        ShiftsService.getShifts(vm.date, id, vm.currentShiftsPage).then(shifts => {
            setShiftRelatedProperties(shifts);
            $anchorScroll('top');
            vm.loading = false;
        });
    }

    function setShiftRelatedProperties(shifts) {
        vm.shifts = shifts && shifts.length == 1 ? shifts[0].vans : [];
        vm.downloadEnabled = hasDownloadPermission; //&& vm.shifts && vm.shifts.length > 0;
        vm.reportsEnabled = hasReportsPermission;
        vm.status = shifts && shifts.length == 1 ? shifts[0].status : '';
        vm.holidays = shifts && shifts.length == 1 ? shifts[0].driverHolidays : [];
        vm.pageCount = shifts && shifts.length == 1 ? shifts[0].pageCount : 0;
        vm.copyMenuEnabled = hasCopyShiftPermission && vm.shifts && vm.shifts.length > 0 && DateService.weekEntirelyInFuture(vm.date);
    }

    function formatDate(d) {
        let date = new Date(d || vm.date);
        date.setHours(12); //hack for Chrome 46 date issue.  Make sure we are not going back a day in DST by forcing to midday.

        if (!isNaN(date.getTime())) {
            return date.toISOString().substring(0, 10);
        }
    }

    function goToToday() {
        $state.go('planner.schedule', {
            week: formatDate(new Date())
        }, {
            reload: false
        });
    }

    function showCopyMenu() {
        vm.reportsMenuOpen = false;
        vm.copyMenuOpen = !vm.copyMenuOpen;
    }

    function copyWeek() {
        vm.copyMenuOpen = false;

        if (vm.copySourceWeek.toDateString() == DateService.getSundayForDate(vm.date).toDateString()) {
            return;
        }

        Alerts.show({
            title: 'Are you sure?',
            text: 'Copying shifts will remove all current driver assignments for this week.  Continue?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Yes, clear & copy',
            cancelButtonText: 'Cancel',
            closeOnConfirm: false,
            closeOnCancel: true,
            showLoaderOnConfirm: true
        }, executeCopy);
    }

    function executeCopy() {
        let sourceWeek = new Date(vm.copySourceWeek);
        sourceWeek.setHours(12);
        let targetWeek = vm.date;
        ShiftsService.copyWeek(sourceWeek, targetWeek).then(result => {
            refreshData();
            Alerts.show('Copy complete!');
        });
    }

    function showReportsMenu() {
        vm.copyMenuOpen = false;
        vm.reportsMenuOpen = !vm.reportsMenuOpen;
    }

    function getReport(reportType) {
        var ieEDGE = navigator.userAgent.match(/Edge/g);
        var ie = navigator.userAgent.match(/.NET/g); // IE 11+
        var oldIE = navigator.userAgent.match(/MSIE/g);

        if (ie || oldIE || ieEDGE) {
            ReportsService.getReport(formatDate(), reportType, true).then(token => {
                var url = window.location.origin + (window.location.pathname || '/') + 'api/reports/' + token[0];
                $window.open(url);
                vm.reportsMenuOpen = false;
            });
        } else {
            ReportsService.getReport(formatDate(), reportType, false).then(data => {
                var dataUrl = 'data:application/pdf;base64,' + data[0];
                var win = window.open();	
                win.document.write('<iframe src="' + dataUrl  + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');	                
            });
        }
    }

    function nextPage() {
        if (vm.currentShiftsPage < vm.pageCount) {
            vm.currentShiftsPage++;
            getShiftsForCurrentPage();
        }
    }

    function previousPage() {
        if (vm.currentShiftsPage > 1) {
            vm.currentShiftsPage--;
            getShiftsForCurrentPage();
        }
    }

    function pagingBarIsEnabled() {
        return vm.pageCount > 1 && $state.current.name != 'planner.driver';
    }

    function assignDriverToShift(shift, driverHoliday) {
        const originalDriver = shift.driver;
        shift.driver = vm.driver.id;
        ShiftsService.postShift(shift, driverHoliday).then(() => {
            refreshData();
            Alerts.showTimedSuccessMessage('Driver successfully assigned');
        }, function(error) {
            shift.driver = originalDriver;
            refreshData();
            Alerts.error(error);
        });
    }

    /////////// Event Listeners ///////////

    $scope.$on('shift-selected', (ev, shift, driverHoliday) => {
        if (vm.driver && vm.driver.id !== shift.driver) {
            if (shift.driver !== 0) {
                Alerts.showConfirmDialog('Replace ' + shift.driverName + ' with ' + vm.driver.firstName + ' ' + vm.driver.lastName + '?', 'Yes, replace driver', function() {
                    assignDriverToShift(shift, driverHoliday);
                });
            } else {
                assignDriverToShift(shift, driverHoliday);
            }
        }
    });

    $scope.$on('shift-cleared', (ev, shift) => {
        Alerts.showConfirmDialog('Remove ' + shift.driverName + ' from this shift?', 'Yes, remove driver', function() {
            ShiftsService.clearShift(shift).then(function() {
                refreshData();
                Alerts.showTimedSuccessMessage('Driver successfully removed');
            }, function(error) {
                Alerts.error(error);
            });
        });
    });

    $scope.$on('driver-selected', (ev, driver) => {
        vm.driver = driver;
        refreshData();
    });

    $scope.$on('holiday-changed', (ev) => {
        refreshData();
    });

    $scope.$on('other-shift-added', (ev) => {
        refreshData();
    });

    $scope.$on('other-shift-deleted', (ev) => {
        refreshData();
    });

    $scope.$on('date-changed-in-driver-view', (ev, date) => {
        vm.date = date;
        refreshData();
    });

}

config.$inject = ['$stateProvider'];

function config($stateProvider) {
    $stateProvider.state('planner', {
        abstract: true,
        controller: controller,
        controllerAs: 'vm',
        parent: 'authorised',
        template: template,
        params: {
            week: new Date()
        },
        url: '/{week:shortdate}'
    });
}

export default config;


// WEBPACK FOOTER //
// ./src/js/components/planner/_planner/index.js